// NotFound.js
import React from 'react';
import './NotFound.css'; // import the CSS file
import { useParams } from 'react-router-dom';

const bare = false;

const NotFound = () => {
  const { customerId } = useParams();
  return (
    <div className={bare ? 'notfound-container bare' : 'notfound-container'}>
      <div className="notfound-content">
        <h1>Page Not Found</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
      </div>
    </div>
  );
};

export default NotFound;
